export default {
  profile: {
    location: 'Madrid, Spain',
    linkedIn: 'Go to LinkedIn',
    github: 'Go to Github'
  },
  menu: {
    home: 'Home',
    projects: 'Projects',
    contact: 'Contact'
  },
  experience: {
    title: 'Experience',
    developed: 'Developed projects in',
    open: 'What did I do in {{company}}?',
    close: 'Close information about {{company}}'
  },
  goTo: 'Go to',
  education: {
    title: 'Education'
  },
  languages: {
    title: 'Languages',
    change: 'Change to Spanish'
  },
  projects: {
    title: 'My Projects'
  }
};
